import React, { useState } from 'react';
import Footer from '../../../layout/Footer/Footer';
import { useAtom } from 'jotai';
import { companyAtom } from '../../../_atoms/company';
import classNames from 'classnames';
import useDarkMode from '../../../hooks/useDarkMode';
import Button from '../../../components/bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { userAtom } from '../../../_atoms/user';
import { createOffer } from '../../../_services/utils';


import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../../components/bootstrap/Modal';
import showNotification from '../../../components/extras/showNotification';
import Label from '../../../components/bootstrap/forms/Label';
import Icon from '../../../components/icon/Icon';
import Textarea from '../../../components/bootstrap/forms/Textarea';

const DefaultFooter = () => {
	const [user] = useAtom(userAtom)
	const [company] = useAtom(companyAtom)
	const [offerDialogOpen, setOfferDialogOpen] = useState(false)
	const { darkModeStatus } = useDarkMode()
	const [isLoading, setIsLoading] = useState(false)
	const date = new Date()

	const { token } = user

	const { t } = useTranslation()

	const offerDialogToggle = () => setOfferDialogOpen(!offerDialogOpen)

	const formik2 = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: user.firstname + " " + user.familyname,
			sector: "",
			notes: ""
		},
		validate: (values) => {
			const errors = {};

			if (!values.sector) {
				errors.sector = t("common.notEmpty");
			}

			if (!values.notes) {
				errors.notes = t("common.notEmpty");
			}

			return errors;
		},
		validateOnChange: false,
		onSubmit: (values) => {
			setIsLoading(true)
			const data = { name: values.name, sector: values.sector, notes: values.notes }
			createOffer(token, data)
				.then(res => {
					setIsLoading(false)
					if (res.data && res.data.code === 200) {
						formik2.setFieldValue("sector", "")
						formik2.setFieldValue("notes", "")
						offerDialogToggle()
						showNotification(
							<span className='d-flex align-items-center'>
								<Icon icon='Info' size='lg' className='me-1' />
								<span>{t("common.success")}</span>
							</span>,
							t("common.offerSuccess"),
						);
					} else {
						showNotification(
							<span className='d-flex align-items-center'>
								<Icon icon='Info' size='lg' className='me-1' />
								<span>{t("common.failure")}</span>
							</span>,
							t("common.error"),
						);
					}
				})
				.catch(err => {
					setIsLoading(false)
					showNotification(
						<span className='d-flex align-items-center'>
							<Icon icon='Info' size='lg' className='me-1' />
							<span>{t("common.failure")}</span>
						</span>,
						t("common.error"),
					);
				})
		},
	});

	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col p-2'>
						<span className='fw-light'>2019 - {date.getFullYear()}</span>
						<Button style={{ marginLeft: 10 }} onClick={offerDialogToggle} color='primary' size="sm" isLight>{t("common.offerUpgrade")}</Button>
					</div>
					<div className='col-auto p-2'>
						<a
							href='https://oxysuite.com'
							target="__blank"
							className={classNames('text-decoration-none', {
								'link-dark': !darkModeStatus,
								'link-light': darkModeStatus,
							})}>
							<small className='fw-bold'>Oxy Suite - {company && company._id ? company.name : ""}</small>
						</a>
					</div>
				</div>
			</div>
			<Modal isOpen={offerDialogOpen} setIsOpen={() => { }}>
				<ModalHeader setIsOpen={offerDialogToggle}>
					<h5>{t("common.offerUpgrade")}</h5>
				</ModalHeader>
				<ModalBody>
					<Label>{t("company.applicationModalText")}</Label>
					<div className='row g-4'>
						<div className='col-12'>
							<FormGroup
								id='sector'
								isFloating
								label={t("common.offerTitle")}
							>
								<Input
									autoComplete='sector'
									value={formik2.values.sector}
									isTouched={formik2.touched.sector}
									invalidFeedback={
										formik2.errors.sector
									}
									isValid={formik2.isValid}
									onChange={formik2.handleChange}
									onBlur={formik2.handleBlur}
									onFocus={() => {
										formik2.setErrors({});
									}}
								/>
							</FormGroup>
						</div>
						<div className='col-12'>
							<FormGroup
								id='notes'
								isFloating
								label={t("common.notes")}
							>
								<Textarea
									rows={7}
									autoComplete='notes'
									value={formik2.values.notes}
									isTouched={formik2.touched.notes}
									invalidFeedback={
										formik2.errors.notes
									}
									isValid={formik2.isValid}
									onChange={formik2.handleChange}
									onBlur={formik2.handleBlur}
									onFocus={() => {
										formik2.setErrors({});
									}}
								/>
							</FormGroup>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='row g-4 w-100'>
						<div className='col-6'>
							<Button
								color='danger'
								className='w-100'
								icon='close'
								isLight
								onClick={offerDialogToggle}>
								{t("common.close")}
							</Button>
						</div>
						<div className='col-6'>
							<Button
								color='success'
								className='w-100'
								isLight
								onClick={formik2.handleSubmit}>
								{t("common.submit")}
							</Button>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</Footer>
	);
};

export default DefaultFooter;
